module.exports = __webpack_public_path__ + "static/media/gallery-2.12ffde38.jpg";